var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, runInAction } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
export class GlobalAdminReportCatalogueViewModel {
    constructor(container) {
        this.definitions = NOT_LOADED;
        this.errorMessage = null;
        this.reportsAdminService = container.reportsAdminService;
        void this.load();
    }
    async load() {
        this.errorMessage = null;
        try {
            const definitions = await this.reportsAdminService.listDefinitions();
            runInAction(() => {
                this.definitions = definitions;
            });
        }
        catch (error) {
            runInAction(() => {
                this.errorMessage = error instanceof Error ? error.message : "Something went wrong";
            });
        }
    }
    get reports() {
        return this.definitions === NOT_LOADED ? [] : this.definitions;
    }
}
__decorate([
    observable
], GlobalAdminReportCatalogueViewModel.prototype, "definitions", void 0);
__decorate([
    observable
], GlobalAdminReportCatalogueViewModel.prototype, "errorMessage", void 0);
__decorate([
    computed
], GlobalAdminReportCatalogueViewModel.prototype, "reports", null);
